import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PtbrExternalLoadsEditModal from './PtbrExternalLoadsEditModal';
import getLocale from '../../../i18n/getLocale';

class PtbrExternalLoadsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      modal_props: false,
      ptbr_external_loads: [],
      data_ptbr_external_load: [],
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.showModal = this.showModal.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.ptbr_external_loads)) {
      this.setState({ptbr_external_loads: newProps.ptbr_external_loads, modal_props: newProps.modal_props});
    }
  }
  
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      type: this.state.type,
      description: this.state.description,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/referencias/ptbr/carga-externa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshTable(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {    
    var botao = (
      <div className="btn-group">
        <button className="btn btn-primary btn-sm" value={cell} onClick={this.showModal}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var ptbr_extra_load_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.deletarCargaExterna);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/referencias/ptbr/carga-externa/' + ptbr_extra_load_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(ptbr_extra_load_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(ptbr_extra_load_id) {
    var data = this.state.ptbr_external_loads;
    data.map(function(dado, index){
      if (dado.id == ptbr_extra_load_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }


  showModal(event) {
    var self = this;
    var ptbr_extra_load_id = event.currentTarget.value;

    var data = self.state.ptbr_external_loads;
    data.map(function(dado, index){
      if (dado.id == ptbr_extra_load_id) {
        self.setState({
          data_ptbr_external_load: dado,
          modal_props: true,
        });
      }
    });
  }



  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formulario.Tipo}</label>
          <input type="text" name="type" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formulario.placeholder.Tipo} value={this.state.type} onChange={this.handleChange.bind(this, 'type')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formulario.Descricao}:</label>
          <input type="text" name="description" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formulario.placeholder.Descricao} value={this.state.description} onChange={this.handleChange.bind(this, 'description')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formulario.botaoAdicionarCargaExternaPTBR}</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.ptbr_external_loads} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.tabela.semCargaExternaPTBR}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.tabela.ID}</TableHeaderColumn>
    <TableHeaderColumn dataField="type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.tabela.Tipo}</TableHeaderColumn>
    <TableHeaderColumn dataField="description" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.tabela.Descricao}</TableHeaderColumn>
    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.tabela.Acoes}</TableHeaderColumn>

  </BootstrapTable>
  <PtbrExternalLoadsEditModal handleAlert={self.props.handleAlert} modal_props={self.state.modal_props} data_ptbr_external_load={self.state.data_ptbr_external_load} refreshTable={self.props.refreshTable} />
</div>
    );
  }
}

export default PtbrExternalLoadsTab;



// WEBPACK FOOTER //
// ./src/Components/Ptbr/Elements/PtbrExternalLoadsTab.js